module.exports = __webpack_public_path__ + "img/setting.45861502.png";